import type { TaskStep } from "@/services/api/data-hub/types";

export type StepBlock =
  | { kind: "step"; step: TaskStep; index: number }
  | {
      kind: "item-group";
      steps: TaskStep[];
      startIndex: number;
      /** Phase step label when items follow a ``kind="step"`` row (e.g. refresh_resource). */
      title?: string;
      phaseStep?: TaskStep;
    };

/**
 * Collapse runs of `kind="item"` rows into one expandable block.
 * When items immediately follow a phase step, merge that step into the group header.
 */
export function groupTaskSteps(steps: TaskStep[]): StepBlock[] {
  const blocks: StepBlock[] = [];
  let i = 0;
  while (i < steps.length) {
    if (steps[i].kind === "item") {
      const start = i;
      const items: TaskStep[] = [];
      while (i < steps.length && steps[i].kind === "item") {
        items.push(steps[i]);
        i += 1;
      }
      const prevIdx = start - 1;
      let title: string | undefined;
      let phaseStep: TaskStep | undefined;
      if (prevIdx >= 0 && steps[prevIdx].kind !== "item") {
        phaseStep = steps[prevIdx];
        title = phaseStep.label;
        const last = blocks[blocks.length - 1];
        if (last?.kind === "step" && last.index === prevIdx) {
          blocks.pop();
        }
      }
      blocks.push({ kind: "item-group", steps: items, startIndex: start, title, phaseStep });
    } else {
      blocks.push({ kind: "step", step: steps[i], index: i });
      i += 1;
    }
  }
  return blocks;
}
